import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

export default class extends Controller {
  static targets = ["select", "createButton", "errors", "nameField"]

  async create(event) {
    event?.preventDefault()

    this.hideErrors()
    const body = this.buildFormData()

    try {
      // FetchRequest auto-handles CSRF; FormData body sets its own content-type.
      const response = await post(
        "/settings/advocate_application_questions/create_custom_field",
        { body, responseKind: "json" }
      )

      const data = await response.json

      if (data.success) {
        this.addOption(data.label, data.value)
        this.hideCreateButton()
      } else {
        this.showErrors(data.errors)
      }
    } catch {
      this.showErrors(["Something went wrong. Please try again."])
    }
  }

  buildFormData() {
    const fd = new FormData()
    const el = this.element

    let label
    if (this.hasNameFieldTarget && this.nameFieldTarget.value.trim()) {
      label = this.nameFieldTarget.value.trim()
    } else {
      const prompt = el.querySelector("input[name='form[prompt]']")
      if (prompt?.value) label = prompt.value.trim().replace(/\?+$/, "").trim()
    }
    if (label) fd.append("form[label]", label.slice(0, 255))

    const responseType = el.querySelector("input[name='form[response_type]']")
    if (responseType?.value) {
      fd.append("form[response_type]", responseType.value)
    }

    for (const input of el.querySelectorAll(
      "input[name='form[response_options][]']"
    )) {
      const val = input.value.trim()
      if (val) fd.append("form[response_options][]", val)
    }

    const placeholderText = el.querySelector(
      "input[name='form[placeholder_text]']"
    )
    if (placeholderText?.value) {
      fd.append("form[placeholder_text]", placeholderText.value)
    }

    const minimum = el.querySelector("input[name='form[minimum]']")
    if (minimum?.value) fd.append("form[minimum]", minimum.value)

    const maximum = el.querySelector("input[name='form[maximum]']")
    if (maximum?.value) fd.append("form[maximum]", maximum.value)

    return fd
  }

  addOption(label, value) {
    const select = this.selectTarget
    let optgroup = select.querySelector('optgroup[label="Custom Fields"]')

    if (!optgroup) {
      optgroup = document.createElement("optgroup")
      optgroup.label = "Custom Fields"
      select.appendChild(optgroup)
    }

    for (const opt of select.options) {
      opt.selected = false
    }

    const option = document.createElement("option")
    option.value = value
    option.textContent = label
    option.selected = true
    optgroup.appendChild(option)
  }

  hideCreateButton() {
    if (this.hasCreateButtonTarget) {
      this.createButtonTarget.classList.add("hidden")
    }
  }

  showErrors(errors) {
    if (this.hasErrorsTarget) {
      this.errorsTarget.textContent = errors.join(", ")
      this.errorsTarget.classList.remove("hidden")
    }
  }

  hideErrors() {
    if (this.hasErrorsTarget) {
      this.errorsTarget.textContent = ""
      this.errorsTarget.classList.add("hidden")
    }
  }
}
